import translationInit from 'common-translations/src/vtj/translation-init'
import commonTranslationsBundle from 'common-translations/src/vtj/translations-bundle'

const instance = translationInit(commonTranslationsBundle.translations)
export default instance
